import { Injectable, TemplateRef } from "@angular/core";

/**
 * Shared, behaviour-preserving extraction of the byte-identical logic that was
 * previously copy-pasted between AppointmentComponent and
 * AppointmentConfirmComponent.
 *
 * Each method receives the calling component as `ctx` (context delegation), so
 * every `this.X` reference from the original inline code becomes `ctx.X` and the
 * logic runs exactly as before. Only provably identical blocks are extracted;
 * divergent methods (viewpatient, getmedicalqns) remain inline in each component.
 */
@Injectable({
  providedIn: "root",
})
export class AppointmentSharedService {
  initFromRoute(ctx: any) {
    ctx.path = ctx.router.url;
    const Splitpath = ctx.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      ctx.scheduleappointmentid = Splitpath[2];
    }
    ctx.getLanguage();
    ctx.getscheduleappointmentId();
    if (localStorage.getItem("countryCodeNew")) {
      ctx.countryCodeNew = localStorage.getItem("countryCodeNew");
    }
  }

  durationFunction(data) {
    const value = Math.round(data);
    const hours = Math.trunc(value / 60);
    const minutes = value % 60;
    if (hours && minutes) {
      return hours + " hour " + minutes + " mins";
    } else if (hours) {
      return hours + " hour ";
    } else {
      return minutes + " mins";
    }
  }

  showExams(ctx: any) {
    ctx.showExamdetails = true;
  }

  hideExams(ctx: any) {
    ctx.showExamdetails = false;
  }

  getscheduleappointmentId(ctx: any) {
    ctx.viewpatient();
    ctx.getmedicalqns();
  }

  applyPatientLocationAndDate(ctx: any) {
    ctx.lat = +ctx.scheduledpatient.latitude;
    ctx.lng = +ctx.scheduledpatient.longitude;
    ctx.scheduleDateShow = ctx.datepipe.transform(
      ctx.scheduledpatient.scheduledOn,
      "MMM d, y"
    );
  }

  getCalendarURL(ctx: any) {
    ctx.appservice
      .getCalendarURL(ctx.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["entity"]) {
          ctx.calendarurl = res["entity"]["calendarURL"];
          if (ctx.calendarurl) {
            window.open(ctx.calendarurl, "_blank");
          }
        }
      });
  }

  getLanguage(ctx: any) {
    ctx.appservice.getlang().subscribe((res) => {
      if (res && res["commonMsg"] && res["validationMessage"]) {
        ctx.validationMessage = res["validationMessage"];
        ctx.selectedlang = res["commonMsg"];
      }
    });
  }

  openModal(ctx: any, template: TemplateRef<any>) {
    ctx.modalRef = ctx.modalService.show(
      template,
      Object.assign(ctx.config, { class: "popup-center-new" })
    );
  }

  confirmationPop(ctx: any) {
    ctx.alert = "Info";
    ctx.generalvalidationMessage = ctx.selectedlang.cancel;
    ctx.openModal(ctx.generalvalidation);
  }

  closemodel() {
    document.getElementById("closepopup").click();
  }

  cancelAppointment(ctx: any) {
    document.getElementById("closepopup").click();
    const data = {
      userId: ctx.scheduledpatient.patientId,
      id: ctx.scheduleappointmentid,
      canceledBy: ctx.scheduledpatient.patientEmail,
      cancelReason: "Unable to come",
    };
    ctx.appservice.cancelAppointment(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          ctx.toastr.success("Your appointment successfully canceled");
          ctx.router.navigate(["/home"]);
        }
      },
      (err) => {
        ctx.appservice.sessionOut(err);
      }
    );
  }

  goToHomePage(ctx: any) {
    ctx.router.navigate(["/home", ctx.scheduleappointmentid]);
  }

  goToHomePageNew(ctx: any) {
    ctx.router.navigate(["/home"]);
  }

  goToThankYouPage(ctx: any) {
    ctx.router.navigate(["/thankyou", ctx.scheduleappointmentid]);
  }

  updatenotify(ctx: any) {
    document.getElementById("closepopup").click();
    ctx.scheduledpatient.notification = ctx.validateEmail;
    ctx.appservice.updatenotify(ctx.scheduledpatient).subscribe((res) => {
      ctx.router.navigate(["/home"]);
    });
  }

  addGoogleCalendar(ctx: any) {
    ctx.getCalendarURL();
  }
}
